import { requiredWarning } from "@/lib/attributeReview/requiredWarning";

export function RequiredStar({ level }: { level: unknown }) {
  const warning = requiredWarning(level);
  if (!warning) return null;
  return (
    <span
      className={
        warning.required
          ? "ml-0.5 align-super text-[0.9em] font-bold text-rose-500 dark:text-rose-400"
          : "ml-0.5 align-super text-[0.9em] font-bold text-amber-500 dark:text-amber-400"
      }
      role="img"
      title={warning.message}
      aria-label={warning.message}
    >
      *
    </span>
  );
}
